const React = require('react')
const SuperAgent = require('superagent')
const Agents = require('../../../../_plugins/lib/agents')
const Tracker = require('../../../../_plugins/lib/tracker')
const Helpers = require('../../../../_plugins/lib/helpers')
const config = require('../../../../config/')
const createReactClass = require('create-react-class');

const Nav = createReactClass({
  mixins: [Agents],

  getInitialState () {
    return {
      showLogin: false,
      showAccount: false,
      userData: {},
      displayErrorMessage: false,
      magicEmailSentMessage: false,
      displayEmailErrorMessage: false,
      loginPopoverAutoOpened: false,
      email: Helpers.getCookie('email') || Helpers.getCookie('Email') || ''
    }
  },

  componentDidMount () {
    this.checkForUserInfo()
    this.validateUserEmail()
  },

  validateUserEmail () {
    const email = Helpers.getCookie('email') || Helpers.getCookie('Email')
    const { userExists: { url, query} } = config
    if (!email || !query) {
      Tracker.track(null, {customer_state: 'unrecognised'}, 'customer_state')
      return
    }
    query.variables.email = email.replace('+', '%2b')
    try {
      SuperAgent
        .post(url)
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({
          query: query.query,
          variables: query.variables
        }))
        .withCredentials()
        .end(this.validateUserEmailCb)
    } catch (error) {
      // console.log( error );
    }
  },

  validateUserEmailCb (err, res) {
    if (err || res.status === 404 || !res.body || !res.body.data || !res.body.data.hasAccount) {
      Tracker.inline('not_valid_user_email', '1')
      return Tracker.track(null, {customer_state: 'recognised_with_email'}, 'customer_state')
    }
    Tracker.inline('valid_user_email', '1')
    Tracker.track(null, {customer_state: 'recognised_with_account'}, 'customer_state')
  },

  toggleLoginDropdown (e) {
    e.preventDefault()
    this.setState(prevState => ({
      showAccount: !prevState.showAccount
    }))
  },

  checkForUserInfo () {
    try {
      SuperAgent
        .post('https://v2.airparks.co.uk/dock-yard/traveller-api/graphql')
        .set('Content-Type', 'application/json')
        .send(JSON.stringify({ query: `fragment vehicle on Vehicle {
        id
        label
        manufacturer
        model
        colour
        registration
    }

    fragment telephone on Telephone {
        id
        label
        number
    }

    fragment address on Address {
        id
        label
        addressLines
        locality
        region
        postalCode
        country
    }

    fragment trip on Trip {
        id
        lag
        to
        from
        departureShortName
        destinationShortName
        bookings {
            agent
            bookingRef
            unprefixedBookingRef
            bookingStatus
            manageBookingLink
            products {
                primary {
                    code
                    type
                    normalisedType
                    content {
                        name
                    }
                }
            }
        }
        recommendations {
            index
            productType
            normalisedProductType
            action {
                type
                value
            }
            content {
                heading
                image
                summary
            }
        }
    }

    fragment card on Card {
        id
        label
        paymentRef
        # cardHolderName
        lastFourDigits
        expiryDate
        issuer
        isCredit
    }

    fragment debit on DirectDebit {
        id
        label
        paymentRef
        agentCode
        accountHolderName
        lastFourDigits
    }

    fragment voucher on Voucher {
      id
      label
      bookingRef
      totalValue
      remainingValue
      currency
      nonFlex
      expires
      created
      productType
      agentCode
      refundValue
      redemptions {
        bookingRef
      }
      cancellationFeeRedeemable
      redemptionConditions {
        agentGroupCode
        productAuthority
      }
    }

    query {
        getTraveller {
            userExtId
            vouchers {
              active {
                ...voucher
              }
              expired {
                ...voucher
              }
              redeemed {
                ...voucher
              }
              refunded {
                ...voucher
              }
            }
            profile {
            title
            givenName
            familyName
            email
            telephones {
                preferred {
                ...telephone
                }
                other {
                ...telephone
                }
            }
            vehicles {
                preferred {
                ...vehicle
                }
                other {
                ...vehicle
                }
            }
            addresses {
                preferred {
                ...address
                }
                other {
                ...address
                }
            }
            paymentMethods {
                cards {
                isPreferredPaymentMethod
                preferred {
                    ...card
                }
                other {
                    ...card
                }
                }
                directDebits {
                isPreferredPaymentMethod
                preferred {
                    ...debit
                }
                other {
                    ...debit
                }
                }
            }
            tripappMetadata {
                autoGeneratedPassword
                hasCompleteBookings
                railsUserID
            }
            }
            upcomingTrips {
            ...trip
            }
            pastTrips {
            ...trip
            }
        }
    }`}))
        .withCredentials()
        .end((err, res) => {
          if (err || res.status === 404 || !res.body || res.body.errors) return this.failedLogin(false)
          this.successfulLogin(res.body.data.getTraveller)
        })
    } catch (e) {
      // return false;
    }
  },

  failedLogin () {
    this.setState({ displayErrorMessage: true, displayEmailErrorMessage: false })
    if (document.cookie.match('(^|; )Email=([^;]+)')) {
      return Tracker.track(null, {customer_state: 'recognised_with_email'}, 'customer_state')
    }
    Tracker.track(null, {customer_state: 'unrecognised'}, 'customer_state')
  },

  successfulLogin (userData) {
    Tracker.track(null, {customer_state: 'authenticated'}, 'customer_state')
    Helpers.setCookie('Email', userData.profile.email, false, config.settings.cookieDomain)
    Helpers.setCookie('email', userData.profile.email, false, config.settings.cookieDomain)
    if (typeof window !== 'undefined') window.loggedInData = userData
    if (this.props.userLoggedInCallback) this.props.userLoggedInCallback(userData)
    this.setState({ userData, displayErrorMessage: false })
  },

  sendMagicLink (e) {
    e.preventDefault()
    const emailAddress = document.querySelector('#signInForm').elements['email'].value.replace('+', '%2b')
    if (!emailAddress) {
      this.setState({ displayEmailErrorMessage: true })
      return
    }

    const referrerUrl = 'https://' + window.location.host

    const payload = {
      email: emailAddress,
      masterBrand: 'AP',
      urlForEmail: referrerUrl
    }

    SuperAgent
      .post('https://v2.airparks.co.uk/dock-yard/traveller-api/graphql')
      .set('Content-Type', 'application/json')
      .send(JSON.stringify({ 
        query: 'mutation ($email: String!, $masterBrand: String!, $urlForEmail: String!) { requestCustomerMagicLoginLinkEmail(email: $email, masterBrand: $masterBrand, urlForEmail: $urlForEmail) { success } }',
        variables: payload
      }))
      .withCredentials()
      .end(() => {
        this.setState({ displayErrorMessage: false, magicEmailSentMessage: true, displayEmailErrorMessage: false })
      })
  },

  logout (e) {
    e.preventDefault()
    SuperAgent
    .post('https://v2.airparks.co.uk/dock-yard/traveller-api/graphql')
    .set('Content-Type', 'application/json')
    .send(JSON.stringify({ 
      query: 'mutation { signOutCustomer{ success } }',
    }))
      .withCredentials()
      .end(() => {
        Tracker.track(null, {customer_state: 'recognised_with_account'}, 'customer_state')
        this.setState({
          showLogin: false,
          showAccount: false,
          discountAgent: false,
          userData: {},
          displayErrorMessage: false,
          magicEmailSentMessage: false,
          displayEmailErrorMessage: false
        })
        if (this.props.userLoggedOutCallback) this.props.userLoggedOutCallback()
      })
  },

  render () {
    const { userData, showAccount, agentData } = this.state
    const { promotionCodeCallback } = this.props
    const discountAgent = agentData.typeRID === 'D'
    if (promotionCodeCallback) {
      let promotionCode = null
      if (discountAgent && userData && userData.profile) {
        promotionCode = Helpers.getParameterByName('promotionCode') || 'members_discount'
      }
      promotionCodeCallback(promotionCode)
    }
    return (
      <div className='navbar'>
        {userData && userData.profile && discountAgent && (
          <div id='members-discount-banner' className='text-center'>
            Discount Unlocked!  Your Airparks reward discount has been applied.
          </div>
        )}
        <div className='navbar-top clearfix'>
          <div className='container-fluid'>
            <span className='brand'>
              <a href='/' title='Airparks'>Airparks</a>
            </span>
            <div id='loginPopover' className='pull-right'>
              {userData && userData.profile && userData.profile.familyName && (
                <div className='dropdown'>
                  <a href='#' data-toggle='dropdown' title='Holiday extras' className='ignore-react-onclickoutside single' onClick={this.toggleLoginDropdown}>Hello {userData.profile.givenName}! Your account<i className='fa fa-chevron-down' /></a>
                  <ul className={`dropdown-menu${showAccount ? ' open' : ''}`}>
                    <li className='dropdown-header hidden-xs' role='presentation'>
                      <div className='h4'>
                        { userData.profile.givenName } { userData.profile.familyName }
                        <div className='small'>
                          { userData.profile.email }
                        </div>
                      </div>
                    </li>
                    <li className='divider hidden-xs' />
                    <li><a className='ignore-react-onclickoutside' href='https://v2.airparks.co.uk/static/?#/users/edit' title='My Account'>My Account</a></li>
                    <li><a href='#' onClick={this.logout} className='ignore-react-onclickoutside userlogin-logout'>Logout</a></li>
                  </ul>
                </div>
              )}
              {(!userData || !userData.profile) && (
                <div>
                  <a href='https://v2.airparks.co.uk/static/?#/users/new_sign_in?referrer=https://www.airparks.co.uk' title='Login' className='nav-login'>Login</a>
                </div>
              )}
            </div>
            <a href='/search.html' title='Search' className='nav-search hidden-xs searchLink'>Search</a>
          </div>
        </div>
        <div className='navbar-bottom clearfix'>
          <div className='container-fluid'>
            <ul className='nav pull-right'>
              <li className='hidden-xs'>
                <a href='/' title='Home'>Home</a>
              </li>
              <li>
                <a href='/faq.html' title='Help &amp; Support'>Help</a>
              </li>
              <li className='hidden-xs'>
                <a href='/about-us.html' title='About Us'>About</a>
              </li>
              <li>
                <a href='/company/contact-us.html' title='Contact Us'>Contact</a>
              </li>
              <li>
                <a href='/manage-existing-booking.html' title='Manage My booking'>Manage My booking</a>
              </li>
              <li className='visible-xs'>
                <a href='/search.html' title='Search'>Search</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
})

module.exports = Nav




// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/nav.jsx